var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0a24.87 24.87 0 0125 24.75v.08c0 7-3.85 14.29-14 24.26L25 60 13.85 49.09C3.85 38.93 0 31.6 0 24.83A24.88 24.88 0 0124.93 0z",
    fill: "#17936f",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "static/media/balloon.2b489c16ff4c3048cc3802b8ad719895.svg";
export { SvgBalloon as ReactComponent };